import { Enumerated } from './Enumerated';

class EVENT_ORDER extends Enumerated {
    static DEFAULT = 'DEFAULT'
    static AREA_CODE = 'AREA_CODE'
}

export { EVENT_ORDER }
